import { ReactNode } from 'react'

export function BannerContent(props: {
  title: ReactNode
  description: ReactNode
}) {
  return (
    <>
      <h1 className='text-2xl font-medium text-cool-50 sm:text-cool-800 md:text-3xl'>
        {props.title}
      </h1>
      <p className='mt-2 text-sm text-cool-50 sm:text-cool-600 md:mt-3 md:text-base xl:text-lg'>
        {props.description}
      </p>
    </>
  )
}
